<template>
    <div class="column">
        <div class="card shipping">
            <div class="card-content">
                <div class="shipping-header text-center">
                    <i class="fas fa-ship"></i>
                    <div>Shipping Information:</div>
                </div>
                <div class="content">
                    <div class="theme-table-container table-container">
                    <table class="shipping-info-table theme-table table is-striped">
                        <thead>
                        <tr>
                            <th scope="col">Balance:</th>
                            <th scope="col">Yard:</th>
                            <th scope="col" style="min-width: 90px;">Lapse:</th>
                            <th scope="col">Buy:</th>
                            <th scope="col">YAD:</th>
                            <th scope="col">Pics:</th>
                            <th scope="col">Docs:</th>
                            <th scope="col">EC:</th>
                            <th scope="col">ETD:</th>
                            <th scope="col">B/L:</th>
                            <th scope="col">Post:</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td data-label="Balance:">{{ car.balance | formatNumber}}</td>
                            <td data-label="Yard:">{{ car.yard }}</td>
                            <td data-label="Lapse:">{{ daysPast(car.created_at) }} Day(s)</td>
                            <td data-label="Buy:">
                                <button class="button is-small date-select">{{ formatDate(car.purchase_date) }}</button>
                            </td>
                            <td data-label="YAD:">
                                <button class="button is-small date-select">{{ formatDate(car.yard_arrival_date) }}
                                </button>
                            </td>
                            <td data-label="Pics:">
                                <button class="button is-small date-select">{{ formatDate(car.yard_pics)}}</button>
                            </td>
                            <td data-label="Docs:">
                                <button class="button is-small date-select">{{ formatDate(car.docs_received) }}</button>
                            </td>
                            <td data-label="EC:">
                                <button class="button is-small date-select">{{ formatDate(car.export_certificate) }}
                                </button>
                            </td>
                            <td data-label="ETD:">
                                <button class="button is-small date-select">{{ formatDate(car.estimated_departure) }}
                                </button>
                            </td>
                            <td data-label="B/L:">
                                <button class="button is-small date-select">{{ formatDate(car.bill_of_landing) }}
                                </button>
                            </td>
                            <td data-label="Post:">
                                <a v-if="car.post_tracking_url != null" :href="'//' + car.post_tracking_url"
                                   target="_blank" class="button is-small date-select">
                                <span class="icon">
                                    <i class="fas fa-link"></i>
                                </span>
                                    <span>{{  formatDate(car.docs_send) }}</span>
                                </a>
                                <button v-else class="button is-small date-select">{{ formatDate(car.docs_send) }}
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="shipping-info-table theme-table table pdf-table is-striped">
                        <thead>
                        <tr>
                            <th scope="col">Invoice#:</th>
                            <th scope="col">E/C:</th>
                            <th scope="col">B/L:</th>
                            <th scope="col">Insurance:</th>
                            <th scope="col">Tracking:</th>
                            <th scope="col" v-if="isAdmin" style="min-width: 110px;">Auc. Docs:</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td data-label="Invoice#:">
                                <button class="button" disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                            <td data-label="E/C:">
                                <a v-if="export_certificates" v-for="bill in export_certificates" :href="bill"
                                   target="_blank" class="button is-primary">
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </a>
                                <button class="button" v-else disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                            <td data-label="B/L:">
                                <a v-if="bills_of_landing" v-for="bill in bills_of_landing" :href="bill" target="_blank"
                                   class="button is-primary">
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </a>
                                <button class="button" v-else disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                            <td data-label="Insurance:">
                                <button class="button" disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                            <td data-label="Tracking:">
                                <button class="button" disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                            <td data-label="Auc. Docs:" v-if="isAdmin">
                                <a v-if="auc_documents" v-for="bill in auc_documents" :href="bill" target="_blank"
                                   class="button is-primary">
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </a>
                                <button class="button" v-else disabled>
                                <span class="icon">
                                  <i class="fas fa-file-pdf"></i>
                                </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: ['car'],
        components: {},
        data() {
            return {
                bills_of_landing: null,
                auc_documents: null,
                export_certificates: null
            }
        },
        mounted() {
            this.bills_of_landing = this.car.documents.bill_of_landings
            this.auc_documents = this.car.documents.auc_documents
            this.export_certificates = this.car.documents.export_certificates
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        },
        methods: {
            daysPast(date, eta) {

                const one_day = 1000 * 60 * 60 * 24;

                const date1 = new Date();
                const date2 = new Date(date);

                const date1_ms = date1.getTime();
                const date2_ms = date2.getTime();

                // Calculate the difference in milliseconds
                const difference_ms = date1_ms - date2_ms;

                // Convert back to days and return
                return Math.round(difference_ms / one_day);
            },
            formatDate(date) {

                if (date) {
                    return moment(date).format('M/D')
                } else {
                    return '---'
                }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/Cars/Car/ShippingInfo.vue